/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInitialSettingsCompletionResponseAllOf,
    GetInitialSettingsCompletionResponseAllOfFromJSON,
    GetInitialSettingsCompletionResponseAllOfFromJSONTyped,
    GetInitialSettingsCompletionResponseAllOfToJSON,
} from './GetInitialSettingsCompletionResponseAllOf';
import {
    GetInitialSettingsCompletionResponseAllOfData,
    GetInitialSettingsCompletionResponseAllOfDataFromJSON,
    GetInitialSettingsCompletionResponseAllOfDataFromJSONTyped,
    GetInitialSettingsCompletionResponseAllOfDataToJSON,
} from './GetInitialSettingsCompletionResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetInitialSettingsCompletionResponse
 */
export interface GetInitialSettingsCompletionResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetInitialSettingsCompletionResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetInitialSettingsCompletionResponse
     */
    message: string;
    /**
     * 
     * @type {GetInitialSettingsCompletionResponseAllOfData}
     * @memberof GetInitialSettingsCompletionResponse
     */
    data: GetInitialSettingsCompletionResponseAllOfData;
}

export function GetInitialSettingsCompletionResponseFromJSON(json: any): GetInitialSettingsCompletionResponse {
    return GetInitialSettingsCompletionResponseFromJSONTyped(json, false);
}

export function GetInitialSettingsCompletionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInitialSettingsCompletionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetInitialSettingsCompletionResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetInitialSettingsCompletionResponseToJSON(value?: GetInitialSettingsCompletionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetInitialSettingsCompletionResponseAllOfDataToJSON(value.data),
    };
}

